import { CognitoConfig, CognitoPoolConfig } from '@aslanpay/portal-common-lib';
import appEnv from 'app/config/appEnv';

const getRedirectSignIn = () => {
  const { origin } = window.location;
  return `${origin}/auth/sso-callback`;
};

const getRedirectSignOut = () => {
  const { origin } = window.location;
  return `${origin}/authentication`;
};

const adminConfig: CognitoPoolConfig = {
  region: appEnv.VITE_COGNITO_REGION,
  userPoolId: appEnv.VITE_COGNITO_USER_POOL_ID,
  userPoolWebClientId: appEnv.VITE_COGNITO_USER_POOL_WEB_CLIENT_ID,
  oauth: {
    domain: appEnv.VITE_COGNITO_OAUTH_DOMAIN,
    scope: ['email', 'openid', 'profile'],
    redirectSignIn: getRedirectSignIn(),
    redirectSignOut: getRedirectSignOut(),
    responseType: 'code',
  },
};

const hasEmployeePoolConfiguration = [
  appEnv.VITE_EMPLOYEE_COGNITO_USER_POOL_ID,
  appEnv.VITE_EMPLOYEE_COGNITO_USER_POOL_WEB_CLIENT_ID,
  appEnv.VITE_EMPLOYEE_COGNITO_OAUTH_DOMAIN,
].every(Boolean);

const employeeConfig: CognitoPoolConfig | undefined = hasEmployeePoolConfiguration
  ? {
      region: appEnv.VITE_COGNITO_REGION,
      userPoolId: appEnv.VITE_EMPLOYEE_COGNITO_USER_POOL_ID,
      userPoolWebClientId: appEnv.VITE_EMPLOYEE_COGNITO_USER_POOL_WEB_CLIENT_ID,
      oauth: {
        domain: appEnv.VITE_EMPLOYEE_COGNITO_OAUTH_DOMAIN,
        scope: ['email', 'openid', 'profile'],
        redirectSignIn: getRedirectSignIn(),
        redirectSignOut: getRedirectSignOut(),
        responseType: 'code',
      },
    }
  : undefined;

const authConfig: CognitoConfig = {
  ...adminConfig,
  contexts: {
    ADMIN: adminConfig,
    ...(employeeConfig ? { EMPLOYEE: employeeConfig } : {}),
  },
};

export default authConfig;
